import React, { useContext, useCallback, useMemo } from 'react';
import { FilterMerchants } from './FilterMerchants';
import { FilterAuthorizationType } from './FilterAuthorizationType';
import { FilterCardType } from './FilterCardType';
import { FilterCardLastFour } from './FilterCardLastFour';
import { FilterAuthorizationCode } from './FilterAuthorizationCode';
import { FilterStan } from './FilterStan';
import { Button } from 'src/components/Button';
import { ListContext, defaultFilters } from '../context';
import { FilterGenericDate } from './FilterGenericDate';
import { DateRange } from 'src/types/dateRange';
import { useTranslation } from 'react-i18next';
import { isEqual } from 'lodash';
import { FilterNameOnCard } from './FilterNameOnCard';
import { FilterCcvResult } from './FilterCcvResult';
import { FilterAvsResponse } from './FilterAvsResponse';
import { FilterMerchantExternalReference } from './FilterMerchantExternalReference';

export const Filters = () => {
  const { dispatch, filters, appliedFilters } = useContext(ListContext);

  const setTransactionDateFilter = useCallback(
    (dateRange: DateRange) =>
      dispatch({ type: 'SET_TRANSACTION_DATE_FILTER', dateRange }),
    [dispatch]
  );

  const resetTransactionDateFilter = useCallback(
    () => dispatch({ type: 'RESET_TRANSACTION_DATE_FILTER' }),
    [dispatch]
  );

  const { t } = useTranslation();

  const filtersApplied = useMemo(() => {
    return isEqual(filters, appliedFilters);
  }, [filters, appliedFilters]);

  const filtersInDefaultState = useMemo(() => {
    return isEqual(filters, defaultFilters);
  }, [filters]);

  return (
    <div className="grid grid-cols-6 gap-5 row-gap-2">
      <div>
        <FilterMerchants />
      </div>
      <div>
        <FilterAuthorizationType />
      </div>
      <div>
        <FilterGenericDate
          filterKey="transactionDate"
          title={t(
            'transactionsManagement.authorizations.list.transmissionDate'
          )}
          setFilterAction={setTransactionDateFilter}
          resetFilterAction={resetTransactionDateFilter}
        />
      </div>
      <div>
        <FilterCardType />
      </div>
      <div>
        <FilterCardLastFour />
      </div>
      <div>
        <FilterNameOnCard />
      </div>
      <div>
        <FilterAuthorizationCode />
      </div>
      <div>
        <FilterCcvResult />
      </div>
      <div>
        <FilterAvsResponse />
      </div>
      <div>
        <FilterMerchantExternalReference />
      </div>
      <div>
        <FilterStan />
      </div>
      <div className="flex items-end">
        <div className="w-px h-8 mr-3 bg-gray-300" />
        <Button
          className="w-1/2 mr-3"
          onClick={() => dispatch({ type: 'APPLY_FILTERS' })}
          disabled={filtersApplied}
          variant={filtersApplied ? 'secondary' : 'primary'}
        >
          {t('transactionsManagement.transactions.list.filters.apply')}
        </Button>
        <Button
          className="w-1/2"
          variant="secondary"
          onClick={() => dispatch({ type: 'RESET_ALL_FILTERS' })}
          disabled={filtersInDefaultState}
        >
          {t('transactionsManagement.transactions.list.filters.clearAll')}
        </Button>
      </div>
    </div>
  );
};
